import { useState } from "react";
import moment from "moment";
import RatingStars from "react-rating-stars-component";

//scss
import "./style.scss";

//assets
import Star from "assets/images/star-gold.svg";
import StarEmpty from "assets/images/star-empty.svg";
import { SvgReviewReplyIcon } from "assets/icons/js/SvgReviewReplyIcon";

//helpers
import getImg from "helpers/getCloudinaryImage";

//components
import Gallery from "../GalleryCarouselPopup";
import ReadMoreWrapper from "components/ReadMoreWrapper";
import { useTheme } from "components/ListingNew/ListingTheme";

const Review = ({ data }) => {
	//gallery carousel stuff
	const [openGallery, setOpenGallery] = useState(false);
	const [clickedImageIndex, setClickedImageIndex] = useState(0);
	const openGalleryAndSetIndex = (index) => {
		setOpenGallery(true);
		setClickedImageIndex(index);
	};
	const theme = useTheme();
	return (
		<>
			<Gallery
				open={openGallery}
				setOpen={setOpenGallery}
				images={data.images}
				clickedImageIndex={clickedImageIndex}
			/>
			<div className="review__wrapper__normal">
				<div className="review__guest">
					<img
						src={
							data.user_profile_image === "/profileImage"
								? data.user_profile_image
								: `https://api.dicebear.com/7.x/initials/svg?seed=${data?.first_name}.svg`
						}
						alt="profileImage"
						width={50}
						height={50}
					/>
					<div className="name-date">
						<div className="text-sm" style={{ color: theme?.primaryTextColor }}>
							{data.first_name}
						</div>
						<div className="text-12px clr-grey">
							{moment(data.guest_review_added_on).format("DD MMM YYYY")}
						</div>
						{data.booking_status === "29" ? (
							<span
								className="critic"
								style={
									theme.name === "xseries"
										? { background: theme?.bookingBtnBackground }
										: {}
								}
							>
								Verified Critic
							</span>
						) : null}
					</div>
				</div>
				<div className="review">
					<div className="review__rating">
						<RatingStars
							edit={false}
							value={data.guest_overall_rating}
							classNames="rating-stars"
							isHalf={true}
						/>
						<div
							className="text-12px-bold"
							style={{ color: theme?.primaryTextColor }}
						>
							{data.guest_overall_rating}
						</div>
						{data?.no_of_guests === 1 && data?.no_of_nights === 1 ? null : (
							<div
								className="text-12px-bold"
								style={{ color: "grey", fontWeight: "400" }}
							>
								• {data?.no_of_guests} Guests for {data?.no_of_nights} Nights
							</div>
						)}
					</div>
					{data.host_review_of_guest_def && (
						<div
							className="text-sm"
							style={{ color: "#666", fontWeight: "normal" }}
						>
							<i>{data.host_review_of_guest_def}</i>
						</div>
					)}
					{data.host_review_of_guest && (
						<div
							className="text-sm"
							style={{ color: theme.baseTextColor, fontWeight: "normal" }}
						>
							<ReadMoreWrapper>{data.host_review_of_guest}</ReadMoreWrapper>
						</div>
					)}

					{data.guest_review_of_host && (
						<div className="review__host-reply">
							<span>
								<SvgReviewReplyIcon />
							</span>
							<div
								className="text-sm"
								style={{ color: theme?.secondaryTextColor }}
							>
								<ReadMoreWrapper>{data.guest_review_of_host}</ReadMoreWrapper>
							</div>
						</div>
					)}

					{data?.images && (
						<div className="images">
							{data.images.map((image, index) => {
								const src = getImg({
									id: image.ImgId,
									version: image.version,
									width: "98",
									height: "90",
								});
								return (
									<img
										src={src}
										alt="#"
										key={index}
										onClick={() => openGalleryAndSetIndex(index)}
									/>
								);
							})}
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default Review;
